import React, {useState} from "react";

const DashboardContext = React.createContext();

function DashboardContexProvider(props) {

    const [toggle, setToggle] = useState(false);
    const [showMenu, setShowMenu] = useState(false);


    const values = {toggle,setToggle,showMenu, setShowMenu}
    return (
        <DashboardContext.Provider value={values}>
            {props.children}
        </DashboardContext.Provider>
      );
    }
export { DashboardContexProvider , DashboardContext};